<template>
  <div>
    <el-card shadow="always">
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("cadastro-embalagem") }} <small>({{ total }} registros)</small>
        </el-col>
      </div>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"
            v-on:keyup.native.enter="fetchRecords()">
            <el-button slot="append" @click="fetchRecords" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button class="right" type="primary" icon="el-icon-plus" @click="add()">{{ $t("adicionar") }}</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }">
        <el-table-column v-if="user.type !== '5'" sortable prop="customer"
          :label="user.type === '2' ? $t('filial') : $t('cliente')" :filters="filters" :filter-method="filterHandler">
        </el-table-column>
        <el-table-column sortable prop="code" :label="$t('codigo')"></el-table-column>
        <el-table-column sortable prop="name" :label="$t('nome')"></el-table-column>
        <el-table-column sortable prop="type" :label="$t('tipo')"></el-table-column>
        <el-table-column prop="height" :label="$t('dimensoes')">
          <template slot-scope="scope">
            {{ scope.row.height }}X{{ scope.row.length }}X{{ scope.row.width }}
          </template>
        </el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button type="info" icon="el-icon-edit" @click="editar(scope.row.id)" circle></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="remove(scope.row.id, scope.row.name)"
              circle></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { PackingService } from "@/services/customers/packing.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "Packing",
  computed: {
    filters() {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        const record = row.customer ? row.customer : "Padrão";
        if (!list.find((x) => x.value === record)) {
          list.push({
            text: record,
            value: record,
          });
        }
      }
      return list.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) return 1;
        if (a.text.toUpperCase() < b.text.toUpperCase()) return -1;
        return 0;
      });
    },
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column["property"];
      if (row[property]) {
        return row[property] === value;
      } else {
        return value === "Padrão";
      }
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PackingService.customers(vm.filter)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({
        name: "packing.add",
      });
    },
    editar: function (id) {
      this.$router.replace({
        name: "packing.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-embalagem", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PackingService.delete(id)
          .then((response) => {
            this.$message({
              type: "success",
              message: i18n.tc("embalagem-eliminado-sucesso"),
            });
            vm.tableData.splice(
              vm.tableData.findIndex((x) => x.id === id),
              1
            );
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      filter: "",
      total: 0,
      user: { type: "2'" },
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>